import { useEffect } from 'react';

const useBeforeUnload = () => {
    // interrupt closing browser tab
    useEffect(() => {
        const handleBeforeUnload = (e) => {
            e.preventDefault();
            e.returnValue = true;
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    // interrupt browser back button
    useEffect(() => {
        const onBackButtonEvent = (e) => {
            e.preventDefault();
            if (window.confirm('Are you sure you want to go back? Any unsaved progress will be lost.')) {
                window.history.back();
            } else {
                window.history.pushState(null, null, window.location.pathname + window.location.search);
            }
        };

        window.history.pushState(null, null, window.location.pathname + window.location.search);
        window.addEventListener('popstate', onBackButtonEvent);

        return () => {
            window.removeEventListener('popstate', onBackButtonEvent);
        };
    }, []);
};

export default useBeforeUnload;
